var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tooltip"},[_vm._t("default"),(_vm.content)?_c('div',{staticClass:"ui-tooltip__content",class:`ui-tooltip__content--${_vm.placement}`},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }